<template>
  <div class="section fullheight has-background-light is-flex" >
    <div class="container">
      <div class="columns is-vcentered is-centered is-mobile" style="min-height:100%;" >
        <div class="column is-4-desktop is-6-tablet" v-if="!('appointments' in me)">
          <h1 class="title">
            Авторизация
          </h1>
          <form class="" @submit.prevent="send">
            <div class="field">
              <p class="control has-icons-left ">
                <input :class="`input ${!login.email || emailValid(login.email)===true || 'is-danger'}`" type="email" placeholder="Email" v-model="login.email" :disabled="loading">
                <span class="icon is-small is-left">
                  <i class="fas fa-envelope"></i>
                </span>
              </p>
              <p :class="`animated shake help ${!login.email || emailValid(login.email)===true || 'is-danger'}`" v-if="!!login.email && emailValid(login.email)!==true">{{emailValid(login.email)}}</p>
            </div>
            <div class="field is-expanded">
              <div class="field has-addons">
                <p class="control has-icons-left is-expanded">
                  <input :class="`input ${!login.password || passValid(login.password)===true || 'is-danger'}`" :type="showPass ? 'text' : 'password'" placeholder="Password" v-model="login.password" :disabled="loading">
                  <span class="icon is-small is-left">
                    <i class="fas fa-lock"></i>
                  </span>
                </p>
                <div class="control">
                  <a class="button" @click.prevent="showPass = !showPass" :disabled="loading">
                    <i :class="`fas fa-eye${!showPass ? '-slash' : ''}`"></i>
                  </a>
                </div>
              </div>
              <p :class="`animated shake help ${!login.password || passValid(login.password)===true || 'is-danger'}`" v-if="!!login.password && passValid(login.password)!==true">{{passValid(login.password)}}</p>
            </div>
            <div class="notification is-warning animated" v-show="errorMsg">
              <button class="delete" type="button" @click.prevent="errorMsg = ''"></button>
              {{errorMsg}}
            </div>
            <div class="field">
              <p class="control">
                <input class="button is-success" :disabled="emailValid(login.email)!==true || passValid(login.password)!==true || loading" type="submit" value="Войти"/>
              </p>
            </div>
          </form>
        </div>
        <div class="column" v-else-if="me.appointments.length > 1">
          <div class="columns">
            <div class="column">
              <h2 class="title">Организация</h2>
              <Input-select
                @input="(val) => setOrganization(val)"
                :value="appointment.organization"
                :items="organizations"
                optionTitle="name"
                optionValue="pk"
                :valueObject="true"
              />
            </div>
            <div class="column">
              <h2 class="title">Выберите роль</h2>
              <Input-select
                @input="(val) => setProfession(val)"
                :value="appointment.profession"
                :items="appointment.organization && grouped[appointment.organization.pk] ? grouped[appointment.organization.pk].map((el) => el.profession) : []"
                optionTitle="title"
                optionValue="id"
                :valueObject="true"
              />
            </div>
          </div>
        </div>
        <div class="column is-4-desktop is-6-tablet "  v-else>
          <button class="button is-fullwidth is-danger" @click.prevent="$store.dispatch('user/logout')">Выйти</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  metaInfo () {
    return {
      title: this.$_.upperFirst(this.$tc(this.$route.meta.title))
    }
  },
  data () {
    return {
      login: {
        email: '',
        password: ''
      },
      showPass: false,
      loading: false,
      errorMsg: '',
      organization: '',
      profession: ''
    }
  },
  computed: {
    ...mapState('user', ['me', 'appointment']),
    grouped () {
      return this.$_.groupBy(this.me.appointments, 'organization.pk')
    },
    organizations () {
      const organizations = this.$_.uniqBy(this.me.appointments.map((el) => el.organization), 'pk')
      return organizations
    }
  },
  methods: {
    emailValid (email) {
      var re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
      return re.test(email) || 'E-mail указан неверно'
    },
    passValid (pass) {
      return pass.length >= 8 || 'Пароль должен быть более 8 символов'
    },
    async send () {
      this.loading = true
      await this.$store.dispatch('user/login', this.login)
        .then(async data => {
          if ('access' in data) {
            await this.$store.dispatch('user/getMe', this.login)
              .then(() => {
                this.login.email = this.login.password = ''
              })
          }
        })
        .catch(error => {
          try {
            this.errorMsg = error.response.data.detail
          } catch (e) {
            this.errorMsg = 'Что то пошло не так...'
            console.log(error)
          }
        })
      this.loading = false
    },
    goBack () {
      // если в запросе есть параметр to с указанием пути куда редиректнуться
      if ('to' in this.$route.query) this.$router.push({ path: this.$route.query.to })
      // если нет, то редиректим назад
      // else this.$router.go(-1)
    },
    setAppointment (appointment) {
      this.$store.commit('user/SET_APPOINTMENT', { raw: appointment })
      try {
        this.$store.commit('user/SET_PERMS', this.me.appointments.filter(el => el.profession.name === appointment.profession.name)[0])
      } catch (error) {
        console.log(error)
      }
      this.goBack()
    },
    setOrganization (organization) {
      // проверить, если в выбранной организации есть текущая профессия
      // то отавляем ее, если нет - выбираем самую первую
      let { profession } = this.appointment
      if (!this.grouped[organization.pk].some((el) => el.profession.id === this.appointment.profession.id)) {
        profession = this.grouped[organization.pk][0].profession
      }
      this.setAppointment({
        profession,
        organization
      })
    },
    setProfession (profession) {
      this.setAppointment({
        ...this.appointment,
        profession
      })
    }
  }
}
</script>
